import React from "react";

import "./Testinomial";

function Testinomial() {
  return <div>Testinomial</div>;
}

export default Testinomial;
